import { configureActiveCartPort } from "~/domains/cart/activeCartPort";
import { ensureActiveCartForContext } from "~/features/cart/cart/api/CartEnsure";

export function registerActiveCartPort(): void {
  configureActiveCartPort(ensureActiveCartForContext);
}
